/**
 * Commonly used constants.
 * Keep this file organized and small.
 *
 * FIXME: This file is getting too big.
 * Need to slowly move constants into "constants" folder to deprecate this file.
 */

// API request status
export const FetchStatus = {
  PENDING: 1, // API call has not being initiated or is in-progress
  SUCCESS: 2, // API call is completed and was successful
  FAILURE: 3, // API call is completed but encountered an error
  BLOCKED: 4, // Content blocked due to missing requirements (e.g., CLIENT_IP cookie)
};

/**
 * Different display type (Ads, for-sale page)
 */
export const DisplayType = {
  ADS: "ADS",
  FOR_SALE: "FOR_SALE",
};

/**
 * Domain Status
 */
export const DomainStatus = {
  ACTIVE: "ACTIVE",
  BLACKLISTED: "BLACKLISTED",
  SUSPENDED_FRAUD: "SUSPENDED_FRAUD",
  SUSPENDED_TRADEMARK: "SUSPENDED_TRADEMARK",
};

/*
 * Events on Parking Lander application
 */
export const EventType = {
  AD_CLICK: "AD_CLICK",
  AD_LOAD: "AD_LOAD",
  BANNER_CLICK: "BANNER_CLICK",
  ERROR: "ERROR",
  KEYWORD_CLICK: "KEYWORD_CLICK",
  KEYWORD_SEARCH: "KEYWORD_SEARCH",
  REDIRECT_FOS: "REDIRECT_FOS",
  RS_LOAD: "RS_LOAD",
  VISIT: "VISIT",
  AD_REDIRECT: "AD_REDIRECT",
  PROXY_FALLBACK: "PROXY_FALLBACK",
  ROLLERADS_BACKFILL_TRIGGER: "ROLLERADS_BACKFILL_TRIGGER",
  INTENT_REDIRECT: "INTENT_REDIRECT",
  AUCTION_EXPOSURE: "AUCTION_EXPOSURE",
};

export const FeedProvider = {
  NONE: "NONE",
  YAHOO: "YAHOO",
  ROLLER_ADS: "ROLLER_ADS",
};

/**
 * Supported query parameters (user-level).
 * All query param keys are lower-cased while parsing
 */
export const QueryParam = {
  DOMAIN: "domain", // string: can be use to specify domain name
  S_TOKEN: "s_token", // string: tracking code
  UUID: "uuid", // UUID sent by the caller
  TEMPLATE: "template", // string: template to render
  SEARCH_BOX: "searchbox", // boolean: Adsense search box show/hide
  SEARCH_BUTTON: "searchbutton", // boolean: Adsense search bottom  show/hide
  SHOW_DOMAIN: "showdomain", // boolean: show/hide
  TDFS: "tdfs", // boolean: show/hide
  BACK_FILL: "backfill", // boolean: Adsense backfill ads
  TERM: "term", // array: Adsense related search terms
  DEBUG_MODE: "debugmode", // boolean: If true then Logger severity is set to TRACE,
  SYSTEM: "system", // string: system name. Overrides cookie
  FEED_ID: "feedid", // number: Use this query param override feed ID value from api (0=AFD, 1=RSOC, 2=YAHOO, 3=MESO, 4=ROLLER_ADS, 5=ROLLER_ADS_1CLICK, 6=ROLLER_ADS_1CLICK_387)
  BANNER_TYPE: "bannertype", // string: Override banner type (FOR_SALE, AUCTION, DBS, BACKORDER, USER_DEFINED)
};

/*
 * Application error codes
 */
export const ErrorCode = {
  ERROR_DOMAIN_STATUS_INVALID: "ERROR_DOMAIN_STATUS_INVALID",
  ERROR_ADSENSE_NO_CAF: "ERROR_ADSENSE_NO_CAF", // caf library not found in global
  ERROR_ADSENSE_CAF: "ERROR_ADSENSE_CAF", // used when page-load fails
  ERROR_ADSENSE_NO_ADS: "ERROR_ADSENSE_NO_ADS",
  ERROR_ADSENSE_NO_RS: "ERROR_ADSENSE_NO_RS",
  ERROR_UNKNOWN_DOMAIN_TYPE: "ERROR_UNKNOWN_DOMAIN_TYPE",
  ERROR_NO_DRID: "ERROR_NO_DRID",
  ERROR_NO_PUBID: "ERROR_NO_PUBID",
  ERROR_YAHOO_NO_ADS: "ERROR_YAHOO_NO_ADS",
  ERROR_YAHOO_FAILED_FETCH_ADS: "ERROR_YAHOO_FAILED_FETCH_ADS",
  ERROR_YAHOO_FAILED_FETCH_RS: "ERROR_YAHOO_FAILED_FETCH_RS",
  ERROR_RSOC_REDIRECT: "ERROR_RSOC_REDIRECT",
  ERROR_AUCTION_DETAILS_URL: "ERROR_AUCTION_DETAILS_URL",
  // Granular config fetch error codes (matches parking-content-site)
  CONFIG_FETCH_TIMEOUT: "CONFIG_FETCH_TIMEOUT",
  CONFIG_FETCH_INVALID_JSON: "CONFIG_FETCH_INVALID_JSON",
  CONFIG_FETCH_UNKNOWN_ERROR: "CONFIG_FETCH_UNKNOWN_ERROR",
  CONFIG_FETCH_HTTP_400: "CONFIG_FETCH_HTTP_400",
  CONFIG_FETCH_HTTP_401: "CONFIG_FETCH_HTTP_401",
  CONFIG_FETCH_HTTP_403: "CONFIG_FETCH_HTTP_403",
  CONFIG_FETCH_HTTP_404: "CONFIG_FETCH_HTTP_404",
  CONFIG_FETCH_HTTP_500: "CONFIG_FETCH_HTTP_500",
  CONFIG_FETCH_HTTP_502: "CONFIG_FETCH_HTTP_502",
  CONFIG_FETCH_HTTP_503: "CONFIG_FETCH_HTTP_503",
  CONFIG_FETCH_HTTP_OTHER: "CONFIG_FETCH_HTTP_OTHER",
  ERROR_ROLLERADS_NO_ADS: "ERROR_ROLLERADS_NO_ADS",
  ERROR_ROLLERADS_BLOCKED: "ERROR_ROLLERADS_BLOCKED",
  ERROR_ROLLERADS_FETCH: "ERROR_ROLLERADS_FETCH",
  ERROR_ROLLERADS_INVALID_URL: "ERROR_ROLLERADS_INVALID_URL",
};

export const LanderCookie = {
  CITY: "city",
  CLIENT_IP: "caf_ipaddr",
  COUNTRY: "country",
  EXPIRY_PARTNER: "expiry_partner",
  SYSTEM: "system",
  TRAFFIC_TARGET: "traffic_target",
  VISITOR_ID: "pvisitor",
  GCP_LB_IP: "gcp_lb_ip",
};

export const System = {
  SMARTNAME: "SN",
  CASHPARKING: "CP",
  PARKWEB: "PW",
};

export const Locale = {
  EN_US: "en",
};

export const TDFSCookie = {
  // This cookie is set in tdfs-api. The value comes from hivemind
  // https://github.com/gdcorp-domains/afternic-tdfs-api/blob/main/internal/tdfs-api/routes/lander/experiment.go#L26
  EXP: "tdfs_exp",
};

export const YahooSingleLanders = {
  SEARCH_DOMAIN_PARKING: {
    projectId: "ugz4q8nuu1",
    hostname: "search-domainparking.com",
    sourceTag: "godad_park_dm_2903_search_domainparking",
  },
  GENERAL_DOMAIN_PARKING: {
    projectId: "uiz0jzljh9",
    hostname: "general-domainparking.com",
    sourceTag: "godad_park_dm_2903_general_domainparking",
  },
  GENERIC_DOMAIN_PARKING: {
    projectId: "uiz0c6krks",
    hostname: "generic-domainparking.com",
    sourceTag: "godad_park_dm_2903_generic_domainparking",
  },
  MISCELLANEOUS_DOMAIN_PARKING: {
    projectId: "uiz11awv1n",
    hostname: "miscellaneous-domainparking.com",
    sourceTag: "godad_park_dm_2903_miscellaneous_domainparking",
  },
  UNIVERSAL_DOMAIN_PARKING: {
    projectId: "uiz0qifc43",
    hostname: "universal-domainparking.com",
    sourceTag: "godad_park_dm_2903_universal_domainparking",
  },
};
